module.exports = __webpack_public_path__ + "img/BACKUP.a04dc278.svg";